<template>
  <div class="smart">
    <div class="container">
      <div class="row">
        <div class="col o-books">
          <svg
            width="72"
            height="72"
            viewBox="0 0 72 72"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_366_13617)">
              <path
                d="M0 36C0 26.4522 3.79285 17.2955 10.5442 10.5442C17.2955 3.79285 26.4522 0 36 0C45.5478 0 54.7045 3.79285 61.4558 10.5442C68.2072 17.2955 72 26.4522 72 36C72 45.5478 68.2072 54.7045 61.4558 61.4558C54.7045 68.2072 45.5478 72 36 72C26.4522 72 17.2955 68.2072 10.5442 61.4558C3.79285 54.7045 0 45.5478 0 36ZM26.568 23.3865C26.3604 23.1716 26.1122 23.0002 25.8377 22.8823C25.5632 22.7644 25.2679 22.7023 24.9692 22.6997C24.6704 22.6971 24.3741 22.754 24.0976 22.8672C23.8211 22.9803 23.5699 23.1474 23.3586 23.3586C23.1474 23.5699 22.9803 23.8211 22.8672 24.0976C22.754 24.3741 22.6971 24.6704 22.6997 24.9692C22.7023 25.2679 22.7644 25.5632 22.8823 25.8377C23.0002 26.1122 23.1716 26.3604 23.3865 26.568L41.8185 45H29.3625C28.7658 45 28.1935 45.2371 27.7715 45.659C27.3496 46.081 27.1125 46.6533 27.1125 47.25C27.1125 47.8467 27.3496 48.419 27.7715 48.841C28.1935 49.2629 28.7658 49.5 29.3625 49.5H47.25C47.8467 49.5 48.419 49.2629 48.841 48.841C49.2629 48.419 49.5 47.8467 49.5 47.25V29.3625C49.5 28.7658 49.2629 28.1935 48.841 27.7715C48.419 27.3496 47.8467 27.1125 47.25 27.1125C46.6533 27.1125 46.081 27.3496 45.659 27.7715C45.2371 28.1935 45 28.7658 45 29.3625V41.8185L26.568 23.3865Z"
                fill="#222222"
              />
            </g>
            <defs>
              <clipPath id="clip0_366_13617">
                <rect width="72" height="72" fill="white" />
              </clipPath>
            </defs>
          </svg>
          &nbsp;
          <span>We are Family</span>
        </div>
      </div>
      <div class="row">
        <div class="col" style="align-content: center">
          <span class="discover">Join our family of Healthcare Providers</span>
        </div>
      </div>
      <div class="row">
        <div class="col" style="align-content: center">
          <span class="choose">COMING SOON</span>
        </div>
      </div>
    </div>
    <div class="row">
      <swiper
        ref="swiperComponentRef"
        class="swiper component"
        :options="swiperOption"
        :style="
          transitionStarted ? { margin: '0 0 0 10%' } : { margin: '0 10% 0 0' }
        "
      >
        <swiper-book
          v-for="(aPublishing, i) in publishings"
          :publishing="aPublishing"
          :index="i"
          :key="`pub_${i}`"
        />
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="container">
      <div class="row">
        <div class="col" style="text-align: center">
          <button
            class="btn btn-signup"
            style="border: none;"
            @click="handleGetStarted"
          >
            Get Started
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper } from "vue-awesome-swiper";
import "swiper/swiper.scss";
import SwiperBook from "./SwiperBook";
import { Editor } from "tiptap";
import {
  BulletList,
  ListItem,
  Bold,
  Italic,
  Underline,
  Strike,
  Placeholder
} from "tiptap-extensions";
//import SwiperClass, { Pagination } from 'swiper'

// import swiper module styles
//import 'swiper/css'
//import 'swiper/css/pagination'
// more module style...

export default {
  name: "OurBooks",
  components: {
    Swiper,
    SwiperBook
  },
  props: {
    publishings: {
      type: Array,
      required: () => []
    }
  },
  data() {
    return {
      editor: null,
      transitionStarted: false,
      modalId: "modal-tutorial",
      visible: false,
      activeIndex: 0,
      swiperOption: {
        slidesPerView: 5,
        spaceBetween: 0,
        centeredSlides: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 2,
            spaceBetween: 1
          },

          // when window width is >= 768px
          640: {
            slidesPerView: 2,
            spaceBetween: 1
          },
          // when window width is >= 768px
          821: {
            slidesPerView: 5,
            spaceBetween: 1
          }
        }
      }
    };
  },
  methods: {
    handleGetStarted() {
      this.$router.push("/signup");
    }
  },
  mounted() {
    this.editor = new Editor({
      extensions: [
        new BulletList(),
        new ListItem(),
        new Bold(),
        new Italic(),
        new Underline(),
        new Strike(),
        new Placeholder({
          emptyNodeClass: "is-empty",
          emptyNodeText: "Add description here",
          showOnlyWhenEditable: true
        })
      ],
      content: null
    });
  }
};
</script>
<style lang="scss" scoped>
.o-books {
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 50px;
  width: 200px;
  height: 55px;

  font-family: "Nunito";
  font-style: normal;
  font-weight: 800;
  font-size: 40px;
  line-height: 55px;
  /* identical to box height */

  text-align: center;

  color: #000000;
}
.discover {
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 25px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 48px;
  line-height: 65px;
  text-align: center;
}
.choose {
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 50px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 27px;
  text-align: center;
  letter-spacing: 0.3em;
  /* Body */
  color: #222222;
  opacity: 0.3;
}

.blurb {
  width: 414px;
  height: 87px;

  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 29px;
  /* or 161% */
  color: rgba(0, 0, 0, 0.7);
  margin-bottom: 50px;
}
.smart {
  padding: 100px;
  background-color: #ffc728;
  .img-smart {
    min-height: 452px;
    display: flex;
    align-items: center;
    position: relative;
    .main-img {
      width: 120%;
      max-width: 120%;
      margin-left: -56px;
    }
  }
  .text-smart {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding-bottom: 15%;
    h2 {
      font-style: normal;
      font-weight: bold;
      font-size: 32px;
      line-height: 44px;
      color: #474d52;
      margin-bottom: 5px;
    }
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 22px;
      color: #474d52;
    }
  }
}
.btn-signup {
  margin-top: 50px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  background: #010610;
  border-radius: 32px;
  height: 40px;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 16px;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  padding: 12px 16px;
  min-width: 150px;
  &:after,
  &:before {
    content: none;
  }
}

@media (max-width: 768px) {
  .smart {
    padding-left: 0;
    padding-right: 0;
  }
}

@media (max-width: 640px) {
  .o-books {
    width: unset;
    height: unset;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
      height: 46px;
      width: 46px;
    }
  }
  .discover {
    font-size: 32px;
    line-height: unset;
  }
}
</style>
